/** @jsx h */
import { h } from 'preact'

const PrintIcon = ({
  style = {},
  fill = '#054060',
  stroke = '#054060',
  width = '19',
  height = '18',
  className = '',
  viewBox = '0 0 19 18'
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`rcc_c_print-icon ${className}`}
    aria-hidden='true'
  >
    <g transform='translate(0.5)'>
      <g transform='translate(3.5)' fill='none' stroke={stroke} strokeMiterlimit='10' strokeWidth='1'>
        <rect width='11' height='6' stroke='none' />
        <rect x='0.5' y='0.5' width='10' height='5' fill='none' />
      </g>
      <g transform='translate(3.5 10)' fill='none' stroke={stroke} strokeMiterlimit='10' strokeWidth='1'>
        <rect width='11' height='8' stroke='none' />
        <rect x='0.5' y='0.5' width='10' height='7' fill='none' />
      </g>
      <path
        d='M286.462,539.878H282.5v-5.5a1.5,1.5,0,0,1,1.5-1.5h15a1.5,1.5,0,0,1,1.5,1.5v5.5h-3.854'
        transform='translate(-282.498 -527.378)'
        fill='none'
        stroke={stroke}
        strokeMiterlimit='10'
        strokeWidth='1'
      />
      <circle cx='1' cy='1' r='1' transform='translate(14.581 6.989)' fill={fill} />
    </g>
  </svg>
)

export default PrintIcon
